require('./aggregatorPensionPlanDetails.scss');

import React from 'react';
import PropTypes from 'prop-types';

// @components
import { AggregatorTableDetails } from 'components/aggregator/aggregatorDetails/aggregatorTableDetails/aggregatorTableDetails';

// @helpers
import { getLastNChars } from 'utilities/stringHelper';

// @constants
const TRANSLATION_KEY_PREFIX = "AggregatorPensionPlanDetails";

const { FormattedText } = require('core/i18n').i18n;

class AggregatorPensionPlanDetails extends React.PureComponent {

    buildName = (item) => {
        // Check Tink fields when user has pensionPlan products ()
        const name = item.get('alias') || item.get('planName');
        const contractNumber = getLastNChars(item.get('number', '').toString());

        return (
            <div className="aggregator-pension-plan-details__name">
                <div className="aggregator-pension-plan-details__name__title">
                    {name}
                </div>
                <div className="aggregator-pension-plan-details__name__contract">
                    <FormattedText value={`${TRANSLATION_KEY_PREFIX}-number`}/>
                    <span className="aggregator-pension-plan-details__name__contract__number">
                        {contractNumber}
                    </span>
                </div>
            </div>
        );
    };

    buildItem = (item) => {
        const quantity = item.get('quantity');
        const unitPrice = item.get('unitPrice');
        const valueDate = item.get('valueDate');
        const balance = item.get('balance');

        return [{
            type: 'custom',
            value: this.buildName(item),
        },{
            type: 'number',
            value: quantity,
        },{
            type: 'amount',
            value: unitPrice,
            bold: true,
        },{
            type: 'date',
            value: valueDate,
        },{
            type: 'amount',
            value: balance,
            bold: true,
        }];
    };

    buildTableValues = () => {
        const { products } = this.props;

        return products.map(item => this.buildItem(item));
    };

    buildTableHeader = () => {
        return [
            <FormattedText key={`${TRANSLATION_KEY_PREFIX}-name`} value={`${TRANSLATION_KEY_PREFIX}-name`}/>,
            <FormattedText key={`${TRANSLATION_KEY_PREFIX}-titles`} value={`${TRANSLATION_KEY_PREFIX}-titles`}/>,
            <FormattedText key={`${TRANSLATION_KEY_PREFIX}-quotation`} value={`${TRANSLATION_KEY_PREFIX}-quotation`}/>,
            <FormattedText key={`${TRANSLATION_KEY_PREFIX}-valorationDate`} value={`${TRANSLATION_KEY_PREFIX}-valorationDate`}/>,
            <FormattedText key={`${TRANSLATION_KEY_PREFIX}-value`} value={`${TRANSLATION_KEY_PREFIX}-value`}/>
        ];
    };

    render() {
        const header = this.buildTableHeader();
        const values = this.buildTableValues();

        return (
            <AggregatorTableDetails
                investmentTable={true}
                values={values}
                header={header}
            />
        );
    }
}

AggregatorPensionPlanDetails.propTypes = {
    products: PropTypes.object,
};

export { AggregatorPensionPlanDetails };
